import './assets/main.css'

createLog('Embeddables Iframe')

import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query'
import { createLog } from 'embeddables/src/Log'
import { EmbeddableMessage } from 'embeddables/src/types/Message'
import { createApp } from 'vue'
import JsonViewer from 'vue-json-viewer'
import App from './App.vue'
import { pejerProvider } from './Pejer'
import { handlePostMessage } from './Pejer/Events'
import router from './router'

const app = createApp(App)

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  },
}
app.use(VueQueryPlugin, vueQueryPluginOptions)
app.use(JsonViewer)

const pejer = pejerProvider(router)
window.addEventListener('message', async (event) => {
  if ((event.currentTarget as Window).origin === event.origin) return

  const postEvent: EmbeddableMessage = event.data
  handlePostMessage((await pejer).provider, postEvent)
})

pejer.then((pejerProviderResponse) => {
  const pejerProvider = pejerProviderResponse.provider
  app.provide(pejerProviderResponse.key, pejerProvider)
  app.use(router)

  app.mount('#app')
})
